// App version shown in the sidebar footer and on the login screen (comment #1/#2, 03/Oct/26),
// so you can see which copy you are testing. Bump with every delivered build (and package.json).
export const APP_VERSION = "0.9.2";
export const RELEASE_LABEL = "New BuildNexx logo, Add member picker, import sheet table, sign-in links, import only dated entries, pin and gridline fixes";
export const RELEASE_DATE = "2026-11-04";
export const POWERED_BY = "Powered by BIM Office Sdn. Bhd.";
